/**
 * Required two-factor — one switch. Members without an authenticator set one
 * up at their next sign-in by password or GitHub, before reaching anything;
 * single sign-on is exempt, because the identity provider enforces its own.
 */
import type React from 'react';
import { color } from '../../theme/tokens';
import { SettingToggle } from '../../components/settings-row';
import { api, apiPath } from '../../lib/api';
import type { OrgIdentity } from '../../lib/types';
import type { SectionProps } from './Security';

export function TwoFactorPolicySection({ organization, identity, apply }: SectionProps): React.JSX.Element {
  const on = identity.policy.requireTwoFactor;
  return (
    <>
      <label style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: 14 }}>
        <SettingToggle
          on={on}
          onToggle={() => void apply(() => api.patch<OrgIdentity>(apiPath`/orgs/${organization.id}/identity/policy`, { requireTwoFactor: !on }))}
        />
        Require two-factor of every member
      </label>
      <p style={{ margin: 0, fontSize: 13, color: color.inkSubtle, lineHeight: 1.6, maxWidth: 640 }}>
        Members without it set it up at their next sign-in, before anything else. People who sign in with single sign-on are
        not asked again — your identity provider handles their second factor. Nobody already signed in is signed out.
      </p>
    </>
  );
}
